export class Model {

  constructor(id: number) {
    this.id = id;
  }

  id: number;

}